export default __webpack_public_path__ + "static/media/TS01.18925ca7.png";